import { ArrowUpRight, Clock, MapPin } from "lucide-react";
import { LOCATIONS } from "../data/site";

export default function Locations({ headingTag: Tag = "h3" }) {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="section-pad"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline">Find Us</div>
            <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Gastro Clinics in Lanka &amp; Chetganj, Varanasi.
            </Tag>
          </div>
          <p className="text-black/65 max-w-md text-[15px] leading-relaxed">
            Morning OPD at Lanka. Evening OPD at Chetganj. Walk-ins welcome, but
            booked patients are seen first.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {LOCATIONS.map((l) => (
            <div
              key={l.id}
              data-testid={`location-card-${l.id}`}
              className="bg-white border border-black/10 rounded-[6px] overflow-hidden"
            >
              <div className="aspect-[16/10] bg-[#fbfaf7] relative">
                <iframe
                  title={l.name}
                  src={l.mapEmbed}
                  width="100%"
                  height="100%"
                  style={{ border: 0, filter: "grayscale(0.4) contrast(1.05)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="p-7 md:p-9">
                <div className="overline">{l.id === "lanka" ? "Morning OPD" : "Evening OPD"}</div>
                <h4 className="mt-3 font-display-semibold text-2xl md:text-3xl leading-tight">
                  {l.name}
                </h4>
                <div className="mt-5 space-y-3 text-[14.5px] text-black/75">
                  <div className="flex items-start gap-3">
                    <MapPin className="h-4 w-4 mt-0.5 text-[#0370AD] shrink-0" />
                    <span>{l.address}</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <Clock className="h-4 w-4 mt-0.5 text-[#0370AD] shrink-0" />
                    <span>
                      {l.days} · {l.hours}
                    </span>
                  </div>
                </div>
                <div className="mt-7 flex flex-wrap gap-3">
                  <a
                    href={l.gbpUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`directions-${l.id}`}
                    className="btn-ghost group"
                  >
                    Get Directions <ArrowUpRight className="h-4 w-4 arrow" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
